import { createFileRoute } from '@tanstack/react-router'
import z from 'zod/v3'
import { HrSlotPortal } from '~/components/routes/hr/planning/hr-toolbar-slot'
import { HrStoreSelector } from '~/components/routes/hr/planning/hr-store-selector'
import { PlanningCalendar } from '~/components/routes/hr/planning/planning'
import { ExportPlanningButton } from '~/components/routes/hr/planning/planning/export-planning-button'
import { PlanningSettingsDialog } from '~/components/routes/hr/planning/planning/planning-settings'
import { PLANNING_READ } from '~/components/routes/hr/tabs'
import { useFeatureFlag } from '~/hooks/useFeatureFlag'
import { resolveStoreSet } from '~/utils/hr/resolveStoreSet'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/hr/planning/calendar')({
  staticData: {
    permission: PLANNING_READ,
  },
  component: RouteComponent,
  validateSearch: z.object({
    weekNumber: z.number().optional(),
    year: z.number().optional(),
  }),
})
withRoutePermissions(Route)

function RouteComponent() {
  const { storeId, exportStoreIds } = Route.useSearch()
  const planningMultiStore = useFeatureFlag('hr-export-planning-multi-store')

  // Multi-boutique : la page affiche `storeId` (tête) mais l'export porte sur tout le set choisi
  // (`exportStoreIds`). `[]` ⇒ undefined pour que l'export interprète « aucun filtre » = toutes.
  const resolvedExportSet = resolveStoreSet(storeId, exportStoreIds)
  const exportStoreSet = resolvedExportSet.length > 0 ? resolvedExportSet : undefined
  const planningExportSet = planningMultiStore ? exportStoreSet : undefined

  return (
    <>
      <HrSlotPortal name="toolbar">
        <HrStoreSelector asCta multi={planningMultiStore} />
        <ExportPlanningButton storeIds={planningExportSet} />
        <PlanningSettingsDialog />
      </HrSlotPortal>
      <PlanningCalendar />
    </>
  )
}
